<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-3">
								<label for="">Código Empresa *</label>
                    		    <input maxlength="70" type="text" v-model="Refaccion.Sku" placeholder="Código Empresa" class="form-control">
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Sku" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                    		    <label for="">Código Fabricante</label>
                    		    <input type="text" v-model="Refaccion.NumParte" placeholder="Código Fabricante" class="form-control">
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NumParte" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
								<label for="">Ítem *</label>
                    		    <input maxlength="70" type="text" v-model="Refaccion.Item" placeholder="Ítem" class="form-control">
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label for="">Sub Ítem *</label>
                    		    <input maxlength="70" type="text" v-model="Refaccion.SubItem" placeholder="Ítem" class="form-control">
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.SubItem" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
							</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
                    		    <label for="">Marca</label>
                    		    <input type="text" v-model="Refaccion.Marca" placeholder="Marca" class="form-control">
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label for="">Modelo</label>
                    		    <input type="text" v-model="Refaccion.Modelo" placeholder="Modelo" class="form-control">
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
								<label for="">Unidad *</label>
                    		    <input v-if="!['','Pieza','Kit','Paquete','Caja'].includes(Refaccion.Unidad)" type="text" v-model="Refaccion.Unidad" placeholder="Unidad" class="form-control">
                    		    <select v-else class="form-control" v-model="Refaccion.Unidad">
									<option value="">Selecciona una Unidad</option>
									<option value="Pieza">Pieza</option>
									<option value="Kit">Kit</option>
									<option value="Paquete">Paquete</option>
									<option value="Caja">Caja</option>
								</select>
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                    		    <label for="">Tipo</label>
                    		    <!-- <input type="text" v-model="Refaccion.Periodo" placeholder="Periodo" class="form-control"> -->
                    		    <select v-model="Refaccion.Tipo" class="form-control">
                    		        <option value="">Seleccione un Tipo</option>
                    		        <option value="1">Genérico</option>
                    		        <option value="2">OEM</option>
                    		    </select>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Tipo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
                    		    <label for="">Costo Unitario</label>
                    		    <vue-numeric
                    		        class="form-control "
                    		        currency="$"
                    		        separator=","
                    		        placeholder="$0.00"
                    		        :precision="2"
                    		        v-model="Refaccion.Valor"
                    		    ></vue-numeric>
                    		</div>
							<div class="col-lg-3">
                    		    <label for="">Fecha Actualización Valor</label>
                    		    <v-date-picker v-model="Refaccion.FechaActValor" :mode="typeCalendar"
                    		        :popover="{
                    		            placement: 'bottom',
                    		            visibility: 'click'
                    		        }"
                    		        :input-props="{
                    		            class: 'form-control cal-black',
                    		            style: 'cursor:pointer;'
                    		        }"
                    		        :locale="'es-MX'"
                    		    />
                    		</div>
							<div class="col-lg-2">
								<label for="">Stock</label>
								<input type="number" v-model="Refaccion.Stock" class="form-control"/>
							</div>
							<div v-show="IdActivo>0" class="col-lg-3">
                    		    <label for="">Tiempo de Reemplazo</label>
                    		    <div class="input-group">
                    		        <input type="text" v-model="Refaccion.Periodo" placeholder="Periodo" class="form-control">
                    		        <select name="" id="" class="form-control" v-model="Refaccion.TipoPeriodo">
                    		            <option value="">Seleccione una Opción</option>
                    		            <option value="1">Meses</option>
                    		            <option value="2">Años</option>
                    		        </select>
                    		    </div>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Periodo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
								<div class="col-lg-4">
                    		    	<label for="">Archivo</label>
                    		    	<div class="custom-file-input-image">
                    		    	    <input @change="uploadImage()" type="file" accept="application/pdf" ref="file" class="custom-file-input" id="validatedCustomFile" required>
                    		    	    <input type="text" v-model="Archivo" class="form-control">
                    		    	    <button type="button" class=""><i class="fas fa-paperclip"></i></button>
                    		    	</div>
                    		</div>
							<div class="col-lg-3" v-show="pTipo==undefined">
								<label for="">Especialidad</label>
								<select v-model="Refaccion.Especialidad" class="form-control">
									<option value="">-Especialidad-</option>
									<option value="1">HVAC</option>
									<option value="2">Refrigeración</option>
									<option value="3">Electricidad</option>
									<option value="4">Hidrosanitario</option>
									<option value="5">Mecánica</option>
									<option value="6">Plomería</option>
									<option value="7">Cocina</option>
									<option value="8">Contraincendios</option>
								</select>
							</div>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="row">
							<div class="col-lg-12">
								<div class="avatar-upload almacen-upload">
									<div class="avatar-edit">
										<input
											id="file2"
											ref="file2"
											type="file"
											name="myfile2"
											@change="uploadImage2()"
											accept=".png, .jpg, .jpeg"
										/>
										<label for="file2"></label>
									</div>
									<div class="avatar-preview imagenes-almacen">
										<div
											id="imagePreviewRefaccion"
											style="background-image: url(Img);"
										></div>
									</div>
								</div>
								<label class="ml-5 pl-3 mt-2">Recomendada 400 x 400</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12 mt-2">
                        <label for="">Descripción</label>
                        <!-- <input maxlength="70" type="text" v-model="Refaccion.Descripcion" placeholder="Nombre" class="form-control"> -->
                        <textarea cols="30" maxlength="70" rows="1" class="form-control" v-model="Refaccion.Descripcion"></textarea>
						<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    </div>
				</div>
				<div class="row" v-if="IdActivo==0">
					<div class="col-lg-12">
						<label for="">Activos</label>
						<treeselect
    						:multiple="true"
    						:options="ListActivos"
    						placeholder="Activos"
    						v-model="ListActivosSeleccionados"
    					/>
					</div>
				</div>
				<div class="mt-3" v-if="Refaccion.IdRefaccion>0">
					<ListForm :ShowButtonTop="DatosTablaProveedor.ShowButtonTop"
					:ShowButton="true"
					:NombreTabla="DatosTablaProveedor.NombreTabla"
					:EmitSeccionTabla="DatosTablaProveedor.EmitSeccionTabla"
                    :TituloBoton="DatosTablaProveedor.TituloBoton"
                    :pConfigLoad="DatosTablaProveedor.ConfigLoad"
					:pShowPager="true">
						<template slot="header_table_form">
							<th>Proveedor</th>
							<th>N° Parte Proveedor</th>
							<th>Precio de Lista</th>
							<th>Última Cotización</th>
							<th>Nombre Contacto</th>
							<th>Tipo de Contacto</th>
							<th>Acciones</th>
						</template>
						<template slot="body_table_form">
							<tr v-for="(item,index) in Proveedores" :key="index">
								<td>{{item.Proveedor}}</td>
								<td>{{item.NoParteProveedor}}</td>
								<td>$ {{Number(item.Precio).toLocaleString('es-MX') }}</td>
								<td class="p-0"><i class="fa fa-calendar"></i> {{$getCleanDate(item.UltimaCotizacion,false)}}</td>
								<td>{{item.NombreContacto}}</td>
								<td>{{item.TipoContacto}}</td>
								<td colspan="2"><Cbtnaccion :isModal="true" 
                                    :pEmitSeccion="DatosTablaProveedor.EmitSeccionTabla" 
                                    :Id="item.IdRefaccionProveedor"
                                    :IrA="DatosTablaProveedor.TituloBoton">

									</Cbtnaccion>
								</td>
							</tr>
						</template>
					</ListForm>
				</div>
            </template>
        </CLoader>
		<Modal 
            :NameModal="DatosTablaProveedor.TituloBoton" 
            :size="'modal-lg'" 
            :Nombre="DatosTablaProveedor.TituloBoton" 
            :pEmitSeccion="DatosTablaProveedor.EmitSeccionTabla"
            :poBtnSave="DatosTablaProveedor.oBtnSave"
        >
            <template slot="Form">
                <FormProveedores :poBtnSave="DatosTablaProveedor.oBtnSave" :IdRefaccion="Refaccion.IdRefaccion"></FormProveedores>
            </template>
        </Modal>
    </div>
</template>
<script>
import moment from "moment"
import Cbtnsave from '@/components/Cbtnsave.vue';
import Cvalidation from '@/components/Cvalidation.vue';
import ListForm from '../../../../components/Clistform.vue';
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import Modal from '@/components/Cmodal.vue';
import FormProveedores from '../refacciones/proveedores/Form.vue';
import $$ from "jquery";

export default{
    name:"Form",
	components:{Modal,ListForm,FormProveedores,Cbtnaccion},
    props:[
        "poBtnSave",
        "IdActivo",
		"pTipo"
    ],
    data(){
        return {
            Modal:true,
            FormName:'Refacciones',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            Refaccion:{
                IdRefaccion:'',
                IdActivo:'',
                Descripcion:'',
                Marca:'',
                Modelo:'',
                Cantidad:'',
                NumParte:'',
                Periodo:'',
                TipoPeriodo:'',
                Tipo:'',
                Valor:0,
                FechaActValor:'',
                Archivo:'',
				Sku:'S/N',
				Item:'',
				Stock:0,
				Unidad:'',
				Imagen:'',
				SubItem:'',
				Especialidad:''
            },
			Imagen:'',
			Proveedores:[],
			DatosTablaProveedor:{
				ConfigLoad:{
                    ShowLoader:true,
                    ClassLoad:true
                },
				ShowButtonTop:false,
                ShowButton:true,
				NombreTabla:"Proveedores",
				EmitSeccionTabla:"Proveedores",
				TituloBoton:"Proveedores",
				oBtnSave:{
                	isModal:true,
                	disableBtn:false,
                	toast:0,
                	nombreModal:"Proveedores",
                	EmitSeccion:"Proveedores"
            	},
				Filtros:{
					TotalItem:0,
                	Pagina:1,
                	Entrada:5,
				}
			},
            Archivo:'Elegir Archivo (0.5MB)',
            errorvalidacion:[],
			ListActivos:[],
			ListActivosSeleccionados:[]
        }
    },
    methods: {
        Guardar(){
            let Fecha='';
			let UrlPost='';
			if (this.IdActivo==0) {
				UrlPost='refacciones/post';
			}
			else{
				UrlPost='refaccionesactivo/post';
			}
			// UrlPost='refacciones/post';
            if (this.Refaccion.FechaActValor!='' && this.Refaccion.FechaActValor!=undefined) {
                let day=this.Refaccion.FechaActValor.getDate();
                let month=this.Refaccion.FechaActValor.getMonth()+1;
                let year=this.Refaccion.FechaActValor.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
            let file = this.$refs.file.files[0];
            let formData=new FormData();
            formData.set('IdRefaccion',this.Refaccion.IdRefaccion);
            formData.set('IdActivo',this.IdActivo);
            formData.set('Descripcion',this.Refaccion.Descripcion);
            formData.set('Marca',this.Refaccion.Marca);
            formData.set('Modelo',this.Refaccion.Modelo);
            formData.set('Cantidad',this.Refaccion.Cantidad);
            formData.set('NumParte',this.Refaccion.NumParte);
            formData.set('Periodo',this.Refaccion.Periodo);
            formData.set('TipoPeriodo',this.Refaccion.TipoPeriodo);
            formData.set('Valor',this.Refaccion.Valor);
            formData.set('FechaActValor',Fecha);
            formData.set('Tipo',this.Refaccion.Tipo);
            formData.set('Archivo',this.Refaccion.Archivo);
			formData.set('Sku',this.Refaccion.Sku);
			formData.set('Item',this.Refaccion.Item);
			formData.set('Stock',this.Refaccion.Stock);
			formData.set('Unidad',this.Refaccion.Unidad);
			formData.set('Imagen',this.Refaccion.Imagen);
			formData.set('SubItem',this.Refaccion.SubItem);
			formData.set('Especialidad',this.Refaccion.Especialidad);
			// formData.set('Proveedor',this.Refaccion.Proveedor);
			formData.set('ListActivos',JSON.stringify(this.ListActivosSeleccionados));
            formData.append('ArchivoFile',file);
			let file2 = this.$refs.file2.files[0];
			formData.append("ImagenFile", file2);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post(UrlPost,formData,{
                headers:{
                    'Content-Type':'multipart/form-data'
                }
            }).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion);
                // this.bus.$emit('Listar');
            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2; 
            });
        },
        Limpiar(){
            this.errorvalidacion=[];
			this.Proveedores=[];
            const  input  = this.$refs.file;
            input .type = 'text'
            input .type = 'file';
            this.Refaccion={
                IdRefaccion:'',
                IdActivo:'',
                Descripcion:'',
                Marca:'',
                Modelo:'',
                Cantidad:'',
                NumParte:'',
                Periodo:'',
                TipoPeriodo:'',
                Tipo:'',
                Valor:0,
				Sku:'S/N',
				Item:'',
				Stock:0,
				Unidad:'',
                Archivo:'',
				Imagen:'',
				SubItem:'',
				Especialidad:'',
                FechaActValor:new Date()
            };
			this.Imagen='';
			const input2 = this.$refs.file2;
			input2.type = 'text'
            input2.type = 'file';
			this.readURL(this.Imagen);
            // if (localStorage.getItem("fechacalendario")) {
			// 	let NuevaFecha = localStorage.getItem("fechacalendario");
			// 	let formatedDate = NuevaFecha.replace(/-/g, "\/");
			// 	this.Refaccion.FechaActValor = new Date(formatedDate);
			// }
            this.Archivo='Elegir Archivo (0.5MB)';
			this.ListActivos=[];
			this.ListActivosSeleccionados=[];
        },
        Recuperar(){
			let UrlRecuperar='';
			// if (this.IdActivo>0) {
			// 	UrlRecuperar='refaccionesactivo/recovery';
			// }
			// else{
			// 	UrlRecuperar='refacciones/recovery';
			// }
			UrlRecuperar='refacciones/recovery';
          this.$http.get(UrlRecuperar,{
            params:{
                    IdRefaccion:this.Refaccion.IdRefaccion
                }
          }).then((res)=>{
                const objres=res.data.data.refaccion;
                this.Refaccion.IdRefaccion=objres.IdRefaccion;
                this.Refaccion.IdActivo=objres.IdActivo;
                this.Refaccion.Descripcion=objres.Descripcion;
                this.Refaccion.Marca=objres.Marca;
                this.Refaccion.Modelo=objres.Modelo;
                this.Refaccion.Cantidad=objres.Cantidad;
                this.Refaccion.NumParte=objres.NumParte;
                this.Refaccion.Periodo=objres.Periodo;
                this.Refaccion.TipoPeriodo=objres.TipoPeriodo;
                this.Refaccion.Tipo=objres.Tipo;
                this.Refaccion.Valor=objres.Valor;
				this.Refaccion.Sku=objres.Sku;
				this.Refaccion.Item=objres.Item;
				this.Refaccion.Stock=objres.Stock;
				this.Refaccion.Unidad=objres.Unidad;
				this.Refaccion.Imagen=objres.Imagen;
				this.Refaccion.SubItem=objres.SubItem;
				this.Refaccion.Especialidad=objres.Especialidad;
                let formatedDate = objres.FechaActValor.replace(/-/g, "\/");
                this.Refaccion.FechaActValor=new Date(formatedDate);
                if (objres.Archivo=='') {
                    this.Refaccion.Archivo='';
                    this.Archivo='Elegir Archivo (0.5MB)';
                }
                else{
                    this.Refaccion.Archivo=objres.Archivo;
                    this.Archivo=objres.Archivo;
                }
				let Foto=objres.Imagen;
				if (Foto != "" && Foto != null) {
					this.Imagen = res.data.data.ruta + this.Refaccion.Imagen;
				}
				this.readURL(this.Imagen);
				this.GetRefaccionProveedor();
				//ACTIVOS SI SE DIO EL CASO
				if (res.data.data.activos!=undefined) {
					if (res.data.data.activos.length>0) {
						this.ListActivosSeleccionados=res.data.data.activos.map((value) => {
							if (value.IdActivo!=0) {
								return value.IdActivo	
							}
						})
					}
				}
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        uploadImage(){
            const image = this.$refs.file.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 0.5) {
                this.$toast.info('Solo se puede subir archivos menores a 1 MB');
                const  input  = this.$refs.file;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.file;
                input.type = 'text'
                input.type = 'file';
                this.Archivo='Elegir archivo (0.5MB)';
                return false;
            }

            this.Archivo=image.name;
        },
		uploadImage2() {
			this.Refaccion.Imagen = this.$refs.file2.files[0];
			const image = this.$refs.file2.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Imagen = e.target.result;
				this.readURL(this.Imagen);
			};
		},
		readURL(input) {
			$$("#imagePreviewRefaccion").css("background-image", "url(" + this.Imagen + ")");
			$$("#imagePreviewRefaccion").hide();
			$$("#imagePreviewRefaccion").fadeIn(650);
		},
        MinimoFecha(){
            let fecha='';
			if(this.Refaccion.FechaActValor!=""){
				var FechaAnterior=new Date(this.Refaccion.FechaActValor);
				var Actual=new Date();
				if (FechaAnterior.getTime()>=Actual.getTime()) {
					fecha=new Date();
				}
				else{
					fecha=moment(this.Refaccion.FechaActValor).add(1,'day').format('YYYY-MM-DD');
					fecha=new Date(fecha);
				}
				
			}
			else{
				fecha=new Date();
			}
			return fecha;
        },
		GetActivos(){
			this.$http.get('activos/get',{
				params:{
					Todos:1
				}
			}).then((res) => {
				this.ListActivos=res.data.data.Activos.map((value)=>{
					return {
						id:value.IdActivo,
						label:value.CodigoActivo
					}
				});
				if (this.Refaccion.IdRefaccion>0) {
					this.Recuperar();
				}
			})
		},
		async GetRefaccionProveedor(){
			this.DatosTablaProveedor.ConfigLoad.ShowLoader=true;
			await this.$http.get('refaccionproveedor/get',{
                params:{
                    IdRefaccion:this.Refaccion.IdRefaccion,
					Entrada:this.DatosTablaProveedor.Filtros.Entrada,
					pag:this.DatosTablaProveedor.Filtros.Pagina
                }
            }).then((res)=>{
                this.Proveedores=res.data.data.refaccionproveedor;
				this.DatosTablaProveedor.Filtros.Entrada=res.data.data.pagination.PageSize;
				this.DatosTablaProveedor.Filtros.TotalItem=res.data.data.pagination.TotalItems;
                // this.UrlDocumentos=res.data.data.urlarchivos;
            }).finally(()=>{
                this.DatosTablaProveedor.ConfigLoad.ShowLoader=false;
            })
		},
		BorrarProveedor(Id){
			this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'refaccionproveedor/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.GetRefaccionProveedor();
                    })
                }
            })
		}
    },
    created(){
        this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id)=>{
            this.ConfigLoad.ShowLoader=true;
            // this.Documento.IdActivo=this.IdActivo
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
			if (this.pTipo!=undefined) {
				this.Refaccion.Especialidad=this.pTipo;
			}
			else{
				this.Refaccion.Especialidad='';
			}
			
            if (Id > 0) {
				this.Refaccion.IdRefaccion = Id;
				this.Recuperar();
			}
            else{
                this.ConfigLoad.ShowLoader=false;
            }
			this.GetActivos();
        });
		this.bus.$off("List_"+this.DatosTablaProveedor.EmitSeccionTabla);
        this.bus.$on("List_"+this.DatosTablaProveedor.EmitSeccionTabla,()=>{
            this.GetRefaccionProveedor();
        });
		this.bus.$off("Delete_"+this.DatosTablaProveedor.EmitSeccionTabla);
        this.bus.$on("Delete_"+this.DatosTablaProveedor.EmitSeccionTabla,(Id)=>{
            this.BorrarProveedor(Id);
        });
    },
    computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>
